import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/AtticatCalculator.jsx';

export default define`Atticat Calculator`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/AtticatCalculator`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {},
});
